function normalizeSearchValue(value: string) {
  return value
    .trim()
    .toLocaleLowerCase("de-DE")
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
}

/** Prüft eine Suchanfrage über mehrere für die Liste sichtbare Textfelder. */
export function matchesListSearch(query: string, values: Array<string | null | undefined>) {
  const normalizedQuery = normalizeSearchValue(query);
  return !normalizedQuery || values.some((value) => normalizeSearchValue(value ?? "").includes(normalizedQuery));
}
